import React from 'react';
import { useLocale } from '../../../../contexts/LocaleContext';
import './Features.css';

const Features: React.FC = () => {
  const { t } = useLocale();

  const features = [
    {
      title: t('eunoiaFeature1Title'),
      description: t('eunoiaFeature1Description'),
      icon: '📝'
    },
    {
      title: t('eunoiaFeature2Title'),
      description: t('eunoiaFeature2Description'),
      icon: '🤖'
    },
    {
      title: t('eunoiaFeature3Title'),
      description: t('eunoiaFeature3Description'),
      icon: '💡'
    },
    {
      title: t('eunoiaFeature4Title'),
      description: t('eunoiaFeature4Description'),
      icon: '🎤'
    },
    {
      title: t('eunoiaFeature5Title'),
      description: t('eunoiaFeature5Description'),
      icon: '🖼️'
    },
    {
      title: t('eunoiaFeature6Title'),
      description: t('eunoiaFeature6Description'),
      icon: '📊'
    }
  ];

  return (
    <section className="features-section">
      <div className="container">
        <h2 className="section-title">{t('featuresEunoiaTitle')}</h2>
        <div className="features-grid">
          {features.map((feature, index) => (
            <div key={index} className="feature-card">
              <div className="feature-icon">{feature.icon}</div>
              <h3 className="feature-title">{feature.title}</h3>
              <p className="feature-description">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;